import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    root: {
        position: 'absolute',
        left: {
            xs: '10px',
            lg: `calc(var(--map-left-offset, 0px) + 20px)`,
        },
        top: '80px',
        bottom: {
            xs: '20px',
            lg: 'auto'
        },
        zIndex: 500
    },
    btn: {
        padding: '9px',
        backgroundColor: 'var(--account-accent, #0C6DDF)',
        borderRadius: '50%',
        '.darkTheme &':{
            backgroundColor:'#181c1e'
        },
        '&:hover': {
            backgroundColor: 'var(--account-accent, #0C6DDF)',
        }
    }
}